"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemWidthAndColumns = void 0;
var MAX_COLUMNS = 10;
var DEFAULT_ITEM_WIDTH_SPAN = [250, 350];

function getItemWidthAndColumns(gutter, totalWidth) {
  var itemWidthSpan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ITEM_WIDTH_SPAN;

  for (var i = MAX_COLUMNS; i > 0; i--) {
    var itemWidth = (totalWidth - gutter * (i - 1)) / i;

    if (itemWidth >= itemWidthSpan[0] && itemWidth <= itemWidthSpan[1]) {
      return {
        itemWidth: itemWidth,
        numColumns: i
      };
    }
  }

  return {
    itemWidth: itemWidthSpan[0],
    numColumns: 1
  };
}

exports.getItemWidthAndColumns = getItemWidthAndColumns;